<template>
  <div class="pt-1 pb-3 px-3 grid-list grid-list-people-delete">
    <div class="grid-list grid-list-4-columns">
      <SelectFarmField
        v-model="peopleId"
        :items="mappedItems"
        title="Nome"
      />

      <TextFarmField
        v-model="people.cpf_cnpj"
        @input="people.cpf_cnpj = maskCpfCnpj(people.cpf_cnpj)"
        title="CPF/CNPJ"
        maxlength="18"
        only-number
        disabled
      />

      <TextFarmField
        v-model="people.phone"
        @input="people.phone = maskPhone(people.phone)"
        title="Telefone"
        maxlength="15"
        only-number
        disabled
      />

      <TextFarmField v-model="people.email" title="E-mail" disabled />
    </div>

    <v-btn @click.stop="toggleDelete" color="transparent" depressed small fab>
      <v-icon color="red">mdi-delete-outline</v-icon>
    </v-btn>

    <v-dialog
      v-if="peopleId && dialogDelete"
      v-model="dialogDelete"
      max-width="500"
      persistent
    >
      <DeleteItemDialog
        @confirm="$emit('delete')"
        @close="dialogDelete = false"
        title="Remover proprietário"
        :name="people.name"
        text="Tem certeza que deseja remover o proprietário"
        change-text="Alteração será aplicada após salvar o formulário."
        btn-text="Remover"
      />
    </v-dialog>
  </div>
</template>

<script>
import TextFarmField from "@/components/fields/farm/Text.vue";
import SelectFarmField from "@/components/fields/farm/Select.vue";
import DeleteItemDialog from "@/components/dialogs/DeleteItem.vue";
import maskCpfCnpj from "@/utils/maskCpfCnpj";
import maskPhone from "@/utils/maskPhone";

export default {
  components: { TextFarmField, SelectFarmField, DeleteItemDialog },
  props: {
    items: Array,
    type: {
      type: String,
      default: "owner",
      validator: (v) => ["owner", "captivator", "contact"].includes(v),
    },
    hasSelected: Array,
    selected: {
      type: [Number, String],
      required: false,
    },
  },
  data: () => ({
    peopleId: null,
    dialogDelete: false,
  }),
  computed: {
    people() {
      return this.items.find(({ id }) => id === this.peopleId) || {};
    },
    parsedItems() {
      return this.items.filter(
        ({ id, is_owner, is_captivator }) =>
          (!this.hasSelected.includes(id) || this.selected === id) &&
          ((!!this.isOwner && !!is_owner) ||
            (!!this.isCaptivator && !!is_captivator) ||
            (!this.isOwner &&
              !is_owner &&
              !this.isCaptivator &&
              !is_captivator)),
      );
    },
    mappedItems() {
      return this.parsedItems.map(({ id, name }) => ({
        text: name,
        value: id,
      }));
    },
    isOwner() {
      return this.type === "owner";
    },
    isCaptivator() {
      return this.type === "captivator";
    },
  },
  methods: {
    toggleDelete() {
      if (this.peopleId) this.dialogDelete = true;
      else this.$emit("delete");
    },
    maskCpfCnpj,
    maskPhone,
  },
  watch: {
    selected(v) {
      this.peopleId = v;
    },
    peopleId(v) {
      this.$emit("change", v);
    },
    people(v) {
      if (!v) return;

      if (v.cpf_cnpj) this.people.cpf_cnpj = this.maskCpfCnpj(v.cpf_cnpj);
      if (v.phone) this.people.phone = this.maskPhone(v.phone);
    },
  },
  created() {
    if (this.selected) this.peopleId = this.selected;
  },
};
</script>

<style lang="scss" scoped>
$gap: 12px;

.grid-list-4-columns {
  $columns: 4;

  display: grid;
  gap: $gap;
  grid-template-columns: repeat(
    $columns,
    calc(25% - ($gap * ($columns - 1) / $columns))
  );
}

.grid-list-people-delete {
  $btnWidth: 40px;

  align-items: flex-end;
  background-color: transparent;
  border-radius: 8px;
  grid-template-columns:
    calc(100% - $btnWidth - $gap)
    $btnWidth;
  transition: all 0.1s linear;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>
